// Filières de Licence
export const filieresLicence = [
  {
    slug: "droit",
    nom: "Droit",
    code: "DRT",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence en Droit",
    conditions: "Titulaires du baccalauréat, toutes séries confondues",
    objectifs: [
      "Donner une formation générale en Droit privé et Droit public pour la poursuite d'études en master",
      "Offrir l'apprentissage de la méthodologie, de l'analyse et des techniques du Droit",
      "Outiller les étudiants à la gestion et à l'analyse juridique",
      "Préparer aux différents métiers du Droit donnant accès à l'administration et aux entreprises",
      "Se familiariser avec les structures et le fonctionnement des principales institutions"
    ],
    debouches: [
      "Domaine juridique, fiscal et contentieux",
      "Expert en conseil et assistance aux entreprises sur les normes fiscales",
      "Juriste de banque, juriste en assurance",
      "Gestionnaire de patrimoine",
      "Juriste dans les cabinets d'avocats d'affaires"
    ],
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800"
  },
  {
    slug: "communication",
    nom: "Communication",
    code: "COM",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence en Communication",
    conditions: "Titulaires du baccalauréat, toutes séries confondues",
    objectifs: [
      "Offrir une formation théorique et méthodologique pour analyser les phénomènes communicationnels",
      "Planifier et évaluer les enjeux de la communication contemporaine",
      "Être sensible aux préoccupations et exigences de la pratique professionnelle"
    ],
    debouches: [
      "Agent d'information",
      "Conseiller en communication interne",
      "Designer/Graphiste (Infographie)",
      "Attaché de presse",
      "Rédacteur publicitaire",
      "Journaliste",
      "Chargé de relations publiques"
    ],
    image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800"
  },
  {
    slug: "informatique",
    nom: "Sciences et Techniques Informatiques",
    code: "INF",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence en Sciences et Techniques Informatiques",
    conditions: "Titulaires du baccalauréat série scientifique (Bac D, C et E)",
    objectifs: [
      "Répondre aux exigences du marché du travail en informatique",
      "Offrir une formation scientifique généraliste et poussée en informatique",
      "Développer des algorithmes appropriés à la résolution de problèmes complexes",
      "Développer et gérer des bases de données relationnelles",
      "Développer des applications bureau, web et mobiles"
    ],
    competences: [
      "Appliquer des structures de données et algorithmes complexes",
      "Développer des applications avec Java, Visual Studio, CMS, Cloud, Windev",
      "Déployer un réseau informatique et assurer la sécurité du système d'information"
    ],
    debouches: [
      "Cadres en informatique dans les entreprises",
      "Métiers de la recherche et du développement",
      "Éditeurs de logiciels, sociétés de consultance",
      "Chef de projet en informatique",
      "Production, Exploitation et Administration"
    ],
    image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=800"
  },
  {
    slug: "histoire",
    nom: "Histoire",
    code: "HIS",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence en Histoire",
    conditions: "Baccalauréat série A1/A2/C/D, Admission par équivalence",
    objectifs: [
      "Donner des connaissances de base en histoire",
      "Rendre les apprenants compétitifs sur le marché du travail et les concours",
      "Fournir les outils nécessaires à la création d'entreprises"
    ],
    debouches: [
      "Métiers de l'enseignement en Histoire et Géographie",
      "Concours administratifs",
      "Gestion du patrimoine",
      "Ambassades et chancelleries",
      "Institutions internationales",
      "Centres d'animation culturelle, Musées"
    ],
    image: "https://images.unsplash.com/photo-1461360370896-922624d12a74?w=800"
  },
  {
    slug: "lettres-modernes",
    nom: "Lettres Modernes",
    code: "LET",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence en Lettres Modernes",
    conditions: "Baccalauréat toutes séries, moyenne en français ≥ 12/20, moyenne en philosophie ≥ 10/20",
    objectifs: [
      "Formation en littératures et civilisations ivoirienne, africaine, francophone et française",
      "Combiner histoire littéraire, étude des genres, analyse et interprétation des textes",
      "Connaissance approfondie de la langue française et de son évolution",
      "Développer des compétences en analyse, synthèse et argumentation"
    ],
    competences: [
      "Connaissance des mécanismes linguistiques du français",
      "Connaissance des méthodes d'analyse de discours",
      "Bonne connaissance des cultures occidentale et africaine",
      "Communiquer avec aisance à l'oral et à l'écrit"
    ],
    debouches: [
      "Enseignant du français dans les collèges et lycées",
      "Rédacteur de presse écrite",
      "Critique littéraire",
      "Lecteur/correcteur",
      "Animateur culturel"
    ],
    image: "https://images.unsplash.com/photo-1457369804613-52c61a468e7d?w=800"
  },
  {
    slug: "mathematiques-actuariat",
    nom: "Mathématiques option Actuariat",
    code: "MAT",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence de Mathématiques appliquées option actuariat",
    conditions: "Titulaires du baccalauréat série scientifique",
    objectifs: [
      "Répondre aux exigences du marché du travail dans les secteurs bancaire et assurantiel",
      "Acquérir les bases théoriques solides pour la poursuite d'études",
      "Développer des modèles mathématiques appropriés"
    ],
    competences: [
      "Appliquer des idées complexes à des situations familières ou nouvelles",
      "Raisonner avec logique et travailler avec analyse",
      "Choisir et mettre en œuvre des méthodes appropriées pour résoudre des problèmes"
    ],
    debouches: [
      "Carrières en météorologie, finances, médecine, biologie",
      "Secteurs bancaires et assurantiels (CNPS, BVRM, BICICI)",
      "Métiers utilisant les mathématiques"
    ],
    image: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800"
  },
  {
    slug: "logistique",
    nom: "Logistique",
    code: "LOG",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence en Logistique",
    conditions: "Titulaires du baccalauréat, toutes séries confondues",
    objectifs: [
      "Formation théorique et méthodologique pour la gestion des flux internes et externes",
      "Analyser les besoins, comparer et choisir entre différents progiciels",
      "Maîtriser les stratégies appliquées à la demande",
      "Connaître les outils du juste à temps et de la production au plus juste"
    ],
    debouches: [
      "Implantation et optimisation de systèmes de gestion de flux",
      "Démarche d'amélioration industrielle",
      "Optimisation des circuits d'approvisionnement et de distribution"
    ],
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800"
  },
  {
    slug: "marketing-management",
    nom: "Management Marketing",
    code: "MKT",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence en Management option Marketing",
    conditions: "Titulaires du baccalauréat, toutes séries confondues",
    objectifs: [
      "Initier aux théories, principes et méthodes des sciences de la gestion",
      "Préparer aux différents métiers de la gestion des organisations",
      "Analyser et comprendre l'environnement économique national et international",
      "Maîtrise des outils modernes de traitement de l'information"
    ],
    debouches: [
      "Élaborer un plan marketing",
      "Procéder à une étude de marché",
      "Améliorer le circuit de distribution d'un produit"
    ],
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800"
  },
  {
    slug: "science-politique",
    nom: "Science Politique",
    code: "POL",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence en Science Politique",
    conditions: "Titulaires du baccalauréat, toutes séries confondues",
    objectifs: [
      "Conférer les aptitudes pour répondre aux problématiques de gouvernance",
      "Fournir les connaissances théoriques et technocratiques propres à la discipline",
      "Comprendre et analyser l'évolution des relations internationales"
    ],
    competences: [
      "Concevoir, mettre en œuvre, suivre et évaluer les activités d'administration publique",
      "Maîtriser les implications de la pensée politique",
      "Concevoir un projet de communication politique"
    ],
    debouches: [
      "Expert des systèmes et institutions politiques",
      "Analyse de l'actualité politique",
      "Organismes gouvernementaux, partis politiques, médias",
      "Conseiller politique"
    ],
    image: "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=800"
  },
  {
    slug: "sciences-comptables",
    nom: "Sciences Comptables et Financières",
    code: "CPT",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence en Sciences Comptables et Financières",
    conditions: "Titulaires du baccalauréat, toutes séries confondues",
    objectifs: [
      "Initier aux théories, principes et méthodes des sciences de la gestion",
      "Préparer aux différents métiers de gestionnaire d'organisations",
      "Maîtrise des outils modernes de traitement de l'information"
    ],
    debouches: [
      "Réaliser toutes les opérations comptables d'une entreprise",
      "Effectuer des analyses financières complexes",
      "Auditeur interne et externe",
      "Comptable, analyste financier, directeur des comptes"
    ],
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800"
  },
  {
    slug: "economie-gestion",
    nom: "Sciences Économiques",
    code: "ECO",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence en Sciences Économiques",
    conditions: "Titulaires du baccalauréat série scientifique",
    objectifs: [
      "Initier aux théories, principes et méthodes des sciences économiques",
      "Analyser et comprendre l'environnement économique national et international",
      "Fournir les moyens d'analyser les grandes problématiques de développement international"
    ],
    debouches: [
      "Emplois dans les sociétés financières et bancaires",
      "Économistes professionnels en analyse conjoncturelle",
      "Analyste financier, statisticien, auditeur",
      "Directeur d'agence, conseiller en gestion de patrimoine"
    ],
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800"
  },
  {
    slug: "geographie",
    nom: "Géographie et Environnement",
    code: "GEO",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence en Géographie et Environnement",
    conditions: "Titulaires du baccalauréat série scientifique",
    specialites: [
      "Géographie humaine et économique",
      "Géographie des Mers et Exploitation des Océans",
      "Géographie Physique et Environnement"
    ],
    objectifs: [
      "Donner des connaissances de base en géographie",
      "Rendre les apprenants compétitifs au niveau des institutions nationales et internationales",
      "Fournir les outils nécessaires pour la gestion de l'espace"
    ],
    debouches: [
      "Enseignant d'Histoire/Géographie",
      "Animateur de projets intercommunaux",
      "Assistant chargé de mission",
      "Assistant cartographe",
      "Assistant paysagiste"
    ],
    image: "https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800"
  },
  {
    slug: "sciences-physiques",
    nom: "Sciences Physiques",
    code: "PHY",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence Sciences Physiques",
    conditions: "Titulaires du baccalauréat série scientifique",
    objectifs: [
      "Former des étudiants à l'interface de la physique et de la chimie",
      "Formation bi-disciplinaire généraliste",
      "Préparer au concours d'entrée à l'École Nationale Supérieure (ENS)",
      "Ouvrir sur les grandes thématiques actuelles (physique quantique, nanophysique, astrophysique)"
    ],
    debouches: [
      "Parcours en physique fondamentale et appliquée",
      "Poursuite en différentes mentions de masters",
      "Profession d'enseignant des collèges et lycées (via ENS)"
    ],
    image: "https://images.unsplash.com/photo-1636466497217-26a8cbeaf0aa?w=800"
  },
  {
    slug: "grh",
    nom: "Gestion des Ressources Humaines",
    code: "GRH",
    type: "licence",
    duree: "3 ans",
    diplome: "Licence en Gestion des Ressources Humaines",
    conditions: "Titulaires du baccalauréat, toutes séries confondues",
    objectifs: [
      "Initier aux théories, principes et méthodes des sciences de la gestion",
      "Préparer aux différents métiers de la gestion des organisations",
      "Approfondir la spécialisation dans le champ des politiques publiques"
    ],
    debouches: [
      "Recruter et sélectionner les candidats",
      "Évaluer les rendements",
      "Élaborer un plan GRH",
      "Mettre en pratique un plan de renforcement des capacités"
    ],
    image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800"
  }
];

// Filières de Master
export const filieresMaster = [
  {
    slug: "droit-affaires-fiscalite",
    nom: "Droit des Affaires et Fiscalité des Entreprises",
    code: "DAF",
    type: "master",
    duree: "2 ans",
    diplome: "Master en Droit des Affaires et Fiscalité des Entreprises",
    conditions: "Licence en Droit ou équivalent",
    objectifs: [
      "Donner une double compétence sur les aspects juridiques, fiscaux, financiers et comptables",
      "Comparer les règles et systèmes fiscaux nationaux et internationaux",
      "Participer à la réflexion sur l'harmonisation des politiques fiscales",
      "Optimiser le montage d'opérations de restructurations, fusions, cessions"
    ],
    competences: [
      "Comparaison des règles et systèmes fiscaux",
      "Analyse du coût fiscal des opérations d'entreprise",
      "Conseil en fiscalité d'entreprise",
      "Veille juridique fiscale"
    ],
    debouches: [
      "Cabinet d'avocats d'affaires",
      "Directions juridiques des entreprises",
      "Juriste de banque",
      "Juriste en assurance",
      "Gestionnaire de patrimoine"
    ],
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800"
  },
  {
    slug: "droit-international-humanitaire",
    nom: "Droit International et Humanitaire",
    code: "DIH",
    type: "master",
    duree: "2 ans",
    diplome: "Master en Droit International et Humanitaire",
    conditions: "Licence en Droit ou équivalent",
    objectifs: [
      "Former les étudiants en droit international et en action humanitaire",
      "Comprendre les défis du Droit International et de l'action humanitaire",
      "Élargir le champ des connaissances liées au droit humanitaire",
      "Maîtriser la procédure de la Cour Pénale Internationale"
    ],
    competences: [
      "Connaissance des règles régissant la société internationale",
      "Prise en charge des réfugiés et déplacés de guerre",
      "Conduite de négociations diplomatiques",
      "Protection des personnes vulnérables"
    ],
    debouches: [
      "Organisations internationales",
      "Cour Pénale Internationale",
      "ONG",
      "HCR",
      "UNICEF",
      "Ministère des Affaires Étrangères"
    ],
    image: "https://images.unsplash.com/photo-1532375810709-75b1da00537c?w=800"
  },
  {
    slug: "droit-maritime",
    nom: "Droit Maritime et Activités Portuaires",
    code: "DMP",
    type: "master",
    duree: "2 ans",
    diplome: "Master en Droit Maritime et Activités Portuaires",
    conditions: "Licence en Droit ou équivalent",
    objectifs: [
      "Former des spécialistes du secteur maritime et portuaire",
      "Traiter les problèmes juridiques liés à la gestion des espaces maritimes",
      "Conseiller les divers opérateurs du secteur maritime"
    ],
    debouches: [
      "Compagnies d'armements maritimes",
      "Banques spécialisées",
      "Compagnies d'assureurs maritimes",
      "Avocat spécialisé en droit maritime",
      "Administration portuaire",
      "Experts maritimes"
    ],
    image: "https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?w=800"
  },
  {
    slug: "finance",
    nom: "Finance",
    code: "FIN",
    type: "master",
    duree: "2 ans",
    diplome: "Master en Finance",
    conditions: "Licence en Gestion, Économie ou équivalent",
    options: ["Banque et Assurance", "Finance d'entreprise et de marché"],
    objectifs: [
      "Approfondir la théorie financière",
      "Analyser l'organisation des systèmes financiers",
      "Concevoir des montages financiers et produits innovants",
      "Gérer le risque dans les institutions financières",
      "Négocier en salle de marché"
    ],
    competences: [
      "Connaissance des théories financières",
      "Ingénierie financière",
      "Gestion des risques financiers",
      "Analyse des marchés financiers"
    ],
    debouches: [
      "Analyste financier",
      "Contrôleur de gestion",
      "Gérant de portefeuille",
      "Gestionnaire de trésorerie",
      "Directeur financier"
    ],
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800"
  },
  {
    slug: "master-logistique",
    nom: "Logistique",
    code: "LOG",
    type: "master",
    duree: "2 ans",
    diplome: "Master en Logistique",
    conditions: "Licence en Logistique, Gestion ou équivalent",
    objectifs: [
      "Optimisation des flux de marchandises et d'informations",
      "Former des praticiens de haut niveau pour la gestion des flux tendus",
      "Gestion d'infrastructures portuaires et aéroportuaires"
    ],
    competences: [
      "Gestion des transports multimodaux",
      "Organisation de la chaîne logistique",
      "Gestion des stocks et approvisionnements",
      "Intégration des systèmes d'information logistique",
      "Audit et mesure des performances"
    ],
    debouches: [
      "Responsable logistique",
      "Responsable planification",
      "Acheteur",
      "Gestionnaire de la chaîne logistique",
      "Gestionnaire de transports"
    ],
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=800"
  },
  {
    slug: "economie-monnaie-banque",
    nom: "Sciences Économiques option Monnaie, Banque et Finance",
    code: "MBF",
    type: "master",
    duree: "2 ans",
    diplome: "Master en Sciences Économiques option Monnaie, Banque, Finance",
    conditions: "Licence en Sciences Économiques ou équivalent",
    objectifs: [
      "Formation théorique solide couplée à la recherche appliquée",
      "Acquérir des connaissances en économie monétaire et finance de marché",
      "Fournir aux banques des cadres de niveau supérieur",
      "Préparer aux carrières de l'enseignement supérieur et de la recherche"
    ],
    debouches: [
      "Cadre dans une banque",
      "Analyste financier",
      "Thèse de doctorat",
      "Enseignement supérieur"
    ],
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800"
  },
  {
    slug: "master-sciences-comptables",
    nom: "Sciences Comptables",
    code: "SCO",
    type: "master",
    duree: "2 ans",
    diplome: "Master en Sciences Comptables",
    conditions: "Licence en Sciences Comptables ou équivalent",
    objectifs: [
      "S'inscrire dans le cursus d'expertise-comptable et de commissariat aux comptes",
      "Rendre les étudiants immédiatement opérationnels",
      "Approfondir les connaissances en comptabilité, audit et contrôle",
      "Initier aux enjeux et méthodes de recherche en comptabilité"
    ],
    debouches: [
      "Expert-comptable",
      "Commissaire aux comptes",
      "Auditeur interne et externe",
      "Crédit manager",
      "Inspecteur des impôts"
    ],
    image: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=800"
  },
  {
    slug: "master-science-politique",
    nom: "Science Politique",
    code: "SPO",
    type: "master",
    duree: "2 ans",
    diplome: "Master en Science Politique",
    conditions: "Licence en Science Politique ou équivalent",
    objectifs: [
      "Conférer toutes les aptitudes pour répondre aux problématiques de gouvernance",
      "Fournir les connaissances théoriques et techniques propres à la discipline"
    ],
    debouches: [
      "Cadres des services publics",
      "Carrières internationales et diplomatiques",
      "Secteur associatif",
      "Assistance parlementaire",
      "Journalisme politique"
    ],
    image: "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=800"
  },
  {
    slug: "gestion-risques-assurance",
    nom: "Gestion des Risques en Assurance et Finance",
    code: "GRA",
    type: "master",
    duree: "2 ans",
    diplome: "Master Spécialisé en Gestion des Risques en Assurance et Finance",
    conditions: "Licence en Finance, Économie, Mathématiques ou équivalent",
    objectifs: [
      "Former des spécialistes en gestion des risques",
      "Concevoir et implémenter des outils de gestion des risques",
      "Fournir des connaissances managériales et financières",
      "Initier à la recherche en sciences actuarielle et financière"
    ],
    competences: [
      "Conception d'outils de gestion des risques",
      "Analyse des risques bancaires et financiers",
      "Gestion actif/passif",
      "Actuariat"
    ],
    debouches: [
      "Directeur financier",
      "Gérant de portefeuille",
      "Actuaire junior",
      "Risk-Manager",
      "Analyste des risques bancaires"
    ],
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800"
  },
  {
    slug: "marketing",
    nom: "Marketing",
    code: "MKT",
    type: "master",
    duree: "2 ans",
    diplome: "Master en Marketing",
    conditions: "Licence en Marketing, Management ou équivalent",
    objectifs: [
      "Élaborer une stratégie marketing et de communication",
      "Conduire un audit marketing",
      "Gérer une force de vente",
      "Mener une recherche commerciale",
      "Conduire une étude de marché"
    ],
    debouches: [
      "Brand manager",
      "Directeur commercial",
      "Directeur marketing",
      "Chef de produit",
      "Chef de publicité"
    ],
    image: "https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=800"
  },
  {
    slug: "master-grh",
    nom: "Gestion des Ressources Humaines",
    code: "GRH",
    type: "master",
    duree: "2 ans",
    diplome: "Master en Gestion des Ressources Humaines",
    conditions: "Licence en GRH, Management ou équivalent",
    objectifs: [
      "Piloter la politique sociale de l'entreprise",
      "Élaborer et mettre en application la procédure de recrutement",
      "Maîtriser les outils de mesure des compétences et performances",
      "Gérer les conflits organisationnels"
    ],
    debouches: [
      "Directeur des ressources humaines",
      "Responsable des ressources humaines",
      "Chef de service de la formation",
      "Responsable du recrutement",
      "Consultant en GRH"
    ],
    image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=800"
  },
  {
    slug: "economie-developpement",
    nom: "Économie du Développement",
    code: "EDD",
    type: "master",
    duree: "2 ans",
    diplome: "Master en Économie du Développement",
    conditions: "Licence en Sciences Économiques ou équivalent",
    objectifs: [
      "Formation poussée à l'analyse des conditions et des politiques de développement",
      "Examiner les liens entre l'analyse économique et les situations réelles",
      "Analyser les problèmes liés à la réforme de la politique économique"
    ],
    debouches: [
      "Responsable de secteur développement",
      "Conseiller en Développement",
      "Créateur d'entreprise éco-business",
      "Chargé de mission",
      "Économiste"
    ],
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800"
  },
  {
    slug: "geomatique",
    nom: "Géomatique",
    code: "GEO",
    type: "master",
    duree: "2 ans",
    diplome: "Master en Géomatique et Ingénierie de l'Environnement et de l'Aménagement",
    conditions: "Licence en Géographie, Environnement ou équivalent",
    objectifs: [
      "Application des outils géomatiques aux questions d'environnement et d'aménagement",
      "Apporter une double expertise thématique et technique",
      "Maîtriser les méthodes géomatiques et le traitement de l'information géographique"
    ],
    competences: [
      "Maîtrise des outils géomatiques (SIG, télédétection, cartographie)",
      "Traitement et analyse de données géographiques",
      "Développement d'applications webmapping",
      "Analyse spatiale et modélisation"
    ],
    debouches: [
      "Administration d'infrastructures SIG",
      "Élaboration d'applications webmapping",
      "Traitement d'images satellites",
      "Gestion de l'environnement et aménagement du territoire"
    ],
    image: "https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800"
  }
];

// Get all filières
export const getAllFilieres = () => [...filieresLicence, ...filieresMaster];

// Get filière by slug
export const getFiliereBySlug = (slug) => {
  return getAllFilieres().find(f => f.slug === slug);
};

// Get filières by type
export const getFilieresByType = (type) => {
  return getAllFilieres().filter(f => f.type === type);
};
